// Acción "Nueva venta" del topbar del Portal Vendedor (mock `portal-vendedor.html` §topbar):
// entrada al wizard desde cualquier pantalla del portal, no solo desde el Home.
// Gateada por `retail.wizard.operate` (rol `vendedor`): un admin de tienda no vende.
import { useNavigate } from '@tanstack/react-router';
import { Plus } from 'lucide-react';
import { Button } from '@/kit';
import { useAuth } from '@/hooks/useAuth';
import type { Permission } from '@/api/types/permissions';

export function NewSaleButton() {
    const navigate = useNavigate();
    const { hasPermission } = useAuth();

    // TD: `retail.wizard.operate` aún NO existe en el PermissionKey del rbac (openapi de
    // platform-rbac-business) — el cast destraba el typecheck del repo mientras el backend agrega
    // el permiso al catálogo. Quitar el cast cuando el enum lo incluya y se regeneren los tipos.
    if (!hasPermission('retail.wizard.operate' as Permission)) return null;

    return (
        <Button
            size="sm"
            leftIcon={<Plus className="size-3.5" aria-hidden />}
            onClick={() => void navigate({ to: '/wizard' })}
        >
            Nueva venta
        </Button>
    );
}
